import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=a7e2e3da"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7e2e3da')) {
      api.createRecord('a7e2e3da', component.options)
    } else {
      api.reload('a7e2e3da', component.options)
    }
    module.hot.accept("./Block.vue?vue&type=template&id=a7e2e3da", function () {
      api.rerender('a7e2e3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Block.vue"
export default component.exports